export default "__VITE_ASSET__BGQi1nlC__"